import Vue from 'vue'

const padLeftZeroDirective = {
  inserted: (el: any, binding: any) => {
    el.addEventListener('input', (event: any) => {
      const { value } = event.target
      const cleanedValue = value.replace(/^0+/, '')
      event.target.value = cleanedValue
    })
  },
  updated: (el: any, binding: any) => {
    el.addEventListener('input', (event: any) => {
      const { value } = event.target
      const cleanedValue = value.replace(/^0+/, '')
      event.target.value = cleanedValue
    })
  },
}

export default padLeftZeroDirective
